import {Component, Inject, OnInit} from '@angular/core';
import { AppService } from "../app.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  private _id: number;
  private _pw: string;
  private _messageTimeout;
  private _textMessage: string;
  private _textMessageShow: boolean;
  private _activeTheme;
  public  url;

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get pw(): string {
    return this._pw;
  }

  set pw(value: string) {
    this._pw = value;
  }

  get messageTimeout() {
    return this._messageTimeout;
  }

  set messageTimeout(value) {
    this._messageTimeout = value;
  }

  get textMessage(): string {
    return this._textMessage;
  }

  set textMessage(value: string) {
    this._textMessage = value;
  }

  get textMessageShow(): boolean {
    return this._textMessageShow;
  }

  set textMessageShow(value: boolean) {
    this._textMessageShow = value;
  }

  get activeTheme() {
    return this._activeTheme;
  }

  set activeTheme(value) {
    this._activeTheme = value;
  }

  constructor(private appService: AppService,
              public dialog: MatDialog) {
  }

  ngOnInit() {
    this.activeTheme = this.appService.getColor();
    this.id = this.appService.getId();
    this.pw = this.appService.getPw();
  }

  public connectT(){
    if(this.pw && this.id) {
      localStorage.clear();
      this.appService.setApiConnection(null);
      this.appService.setInterfaceResource(null);
      this.appService.resetAllWorkers();
      this.appService.reconnect(false);
      this.appService.setConnectError("WRONG_DATA_INPUT");
      this.appService.setId(this.id);
      this.appService.setPw(this.pw);
      if (navigator.onLine == true) {
        this.appService.loadTerminal(false).catch(connectMessage => {
          console.log('catch the id error? ' + connectMessage);
          this.message(connectMessage, 3500);
        })
      } else {
        this.message("TERMINAL_IS_OFFLINE", 3500);
      }
    } else { this.message("INPUT_FIELD_IS_EMPTY",3500);

    }
  }

  private message(message: string, millisec: number) {
    clearTimeout(this.messageTimeout);
    this.textMessage = message;
    this.textMessageShow = true;
    this.messageTimeout = setTimeout(() => {
      this.textMessageShow = false
    }, millisec);
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(LoginComponentUrlDialog, {
      width: '400px',
      data: { url: this.url }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.appService.setHostUrl(result);
    });
  }
}

@Component({
  selector: 'login-component-url-dialog',
  templateUrl: 'login-component-url-dialog.html',
})
export class LoginComponentUrlDialog {

  constructor(
    public dialogRef: MatDialogRef<LoginComponentUrlDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
